import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

export function OverdueActionsCard(): React.ReactElement {
  const loading = false
  const hasPayload = true
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasPayload)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Overdue actions"
      showTitleChevron={false}
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-alerts-list">
        <details>
          <summary>
            <span className="alerts-row-label">Unscheduled Treatment</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">1</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Unposted Procedures</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">1</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Broken Appointment</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">0</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Insurance Claim</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">0</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Recall</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">3</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Missing Codes</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">0</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
        <details>
          <summary>
            <span className="alerts-row-label">Unsigned Notes</span>
            <span className="alerts-row-count-pill">
              <span className="alerts-row-count">0</span>
            </span>
          </summary>
          <div className="alerts-row-content">Content TBD</div>
        </details>
      </div>
    </DashboardSectionCard>
  )
}
